<template>
  <div class="section">
    <div class="container">
      <div class="card" @click="goToStudents()">
          <p class="card-title">Estudiantes</p>
          <p class="card-content card-content-other">Mira el progreso de tus estudiantes</p>
      </div>
      <div class="card" @click="goToRoute(1)">
          <p class="card-title">Vocabulary</p>
          <p class="card-content card-content-other">Crea tus unidades de vocabulario</p>
      </div>
      <div class="card" @click="goToRoute(2)">
          <p class="card-title">Listening</p>
          <p class="card-content card-content-other">Crea tus unidades de escucha</p>
      </div>
      <div class="card" @click="goToRoute(3)">
          <p class="card-title">Speaking</p>
          <p class="card-content card-content-other">Crea tus unidades de habla</p>
      </div>
    </div>
  </div>
</template>
      
<script>
import router from "@/router";

export default {
  name: "SectionView",
  data() {
    return {
      section: null,
      sectionData: {
        name: "",
        visible: false,
      },
    };
  },
  methods: {
    goToRoute(route) {
      router.push("/unities/" + route + "/" + this.$route.params.id);
    },
    goToStudents() {
      router.push("/see-users/" + this.$route.params.id);
    },
  },
};
</script>
    
<style scoped>
.section {
  flex: 1;
  background-color: var(--not-so-grey);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

p {
  margin: 0;
}

.container {
  width: 70%;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  cursor: pointer;
  background-color: #f4f8f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  padding: 10px;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
}

.card-content {
  color: var(--another-grey);
  text-align: start;
}
.card-content-other {
  font-style: italic;
}

.card-add {
  align-items: center;
  justify-content: center;
}

.card:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}

</style>